import { useCallback, useEffect, useRef, useState } from 'react';
import { workshopFinance } from '../../services/workshopFinance';
import { uniqueDocuments } from '../accounting/workshopFinanceModel';

const EMPTY = { items: [], total: 0, permissions: {}, loading: false, error: '' };

// Independent read-only source: never turn workshop documents into visit totals.
export default function useOperationsDocuments({ canView, vehicleId, canViewPayroll }) {
    const [state, setState] = useState(EMPTY);
    const generation = useRef(0);
    const load = useCallback(async () => {
        const version = ++generation.current;
        if (!canView) { setState(EMPTY); return; }
        setState({ ...EMPTY, loading: true });
        try {
            const params = { limit: 100, offset: 0 };
            if (vehicleId) params.vehicle_id = vehicleId;
            const { data } = await workshopFinance.documents(params);
            if (data?.success !== true || !Array.isArray(data.items) || !Number.isInteger(data.total) || data.total < 0) throw new Error('Invalid document list');
            if (version !== generation.current) return;
            const items = uniqueDocuments(data.items).filter((document) => document.kind !== 'payroll' || canViewPayroll);
            setState({ items, total: data.total, permissions: data.permissions || {}, loading: false, error: '' });
        } catch (_) {
            if (version === generation.current) setState({ ...EMPTY, error: 'تعذر تحميل المصروفات والإيرادات المستقلة. نتائج هذا المصدر غير مكتملة.' });
        }
    }, [canView, vehicleId, canViewPayroll]);
    useEffect(() => { load(); return () => { generation.current += 1; }; }, [load]);
    return { ...state, load };
}
